/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { userDonationInfoModelSchema } from "../userDonationInfoModelSchema.ts";
import { z } from "zod";

export const getApiDonationsByUserIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор пользователя")
    })

/**
 * @description Успешно
 */
export const getApiDonationsByUserId200Schema = z.lazy(() => userDonationInfoModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiDonationsByUserId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiDonationsByUserId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiDonationsByUserId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiDonationsByUserId500Schema = z.lazy(() => badResponseModelSchema)

export const getApiDonationsByUserIdQueryResponseSchema = z.lazy(() => getApiDonationsByUserId200Schema)